export const SET_SEARCH_VALUE = 'SET_SEARCH_VALUE';
export const SET_SEARCH_CONTEXT = 'SET_SEARCH_CONTEXT';
